import { Component, OnInit } from "@angular/core";

import { Observable } from "rxjs";

import { markAsTouched, updateValueAndValidity } from "@dffedb/forms";
import { DffSimpelDialog, ToastService } from "@dffedb/ui";
import { getErrorMessage } from "@dffedb/util";

import { ForbrugsnotifikationType } from "./model/forbrugsnotifikation-opsaetning.model";
import { ForbrugsnotifikationOpsaetningViewModel } from "./model/forbrugsnotifikation-opsaetning.view-model";
import { ForbrugsnotifikationService } from "./shared/forbrugsnotifikation.service";

@Component({
    templateUrl: "./forbrugsnotifikation.component.html",
    styleUrls: ["./forbrugsnotifikation.component.scss"]
})
export class ForbrugsnotifikationComponent implements OnInit {
    public afmelder = false;
    public gemmer = false;
    public vm$: Observable<ForbrugsnotifikationOpsaetningViewModel>;

    constructor(
        private readonly service: ForbrugsnotifikationService,
        private readonly toaster: ToastService,
        private readonly dialog: DffSimpelDialog
    ) {}

    public ngOnInit(): void {
        this.vm$ = this.service.hent();
    }

    public async onAfmeldClick(vm: ForbrugsnotifikationOpsaetningViewModel): Promise<void> {
        const afmeld = await this.dialog.openJaNej("Ønsker du at afmelde?", "");
        if (!afmeld) {
            return;
        }
        this.afmelder = true;
        vm.formGroup.get("udsendelse.type").setValue(ForbrugsnotifikationType.brev);
        this.service
            .gem(vm)
            .then(() => {
                this.afmelder = false;
                this.toaster.visInfo("Du er nu afmeldt");
            })
            .catch((error) => {
                this.afmelder = false;
                this.toaster.visFejl("Der opstod en fejl: " + getErrorMessage(error));
            });
    }

    public onTilmeldClick(vm: ForbrugsnotifikationOpsaetningViewModel): void {
        markAsTouched(vm.formGroup);
        updateValueAndValidity(vm.formGroup);

        if (vm.formGroup.invalid) {
            return;
        }

        this.gemmer = true;
        this.service
            .gem(vm)
            .then(() => {
                this.gemmer = false;
                this.toaster.visInfo("Du er nu tilmeldt");
            })
            .catch((error) => {
                this.gemmer = false;
                this.toaster.visFejl("Der opstod en fejl: " + getErrorMessage(error));
            });
    }

    public onGemClick(vm: ForbrugsnotifikationOpsaetningViewModel): void {
        markAsTouched(vm.formGroup);
        updateValueAndValidity(vm.formGroup);

        if (vm.formGroup.invalid) {
            return;
        }

        this.gemmer = true;
        this.service
            .gem(vm)
            .then(() => {
                this.gemmer = false;
                this.toaster.visInfo("Oplysningerne er gemt");
            })
            .catch((error) => {
                this.gemmer = false;
                this.toaster.visFejl("Der opstod en fejl: " + getErrorMessage(error));
                console.log(getErrorMessage(error));
            });
    }
}
